import React from 'react'
import { IResidenceDetailHeaderProps } from './residence-detail-header-props.interface'
import './residence-detail-header.scss'

import { icon_phone, icon_map } from 'icons'
import { IonIcon } from '@ionic/react'
import { useTranslation } from 'react-i18next'
import { Rating } from 'components'

const ResidenceDetailHeader: React.FC<IResidenceDetailHeaderProps> = ({ residence }) => {
  const { t } = useTranslation()
  return (
    <div className="edisu-residence-detail-header">
      <div>
        <h2>{residence.nome}</h2>
        <div className="residence-info-cnt">
          <div className="edisu-residence-info">
            <div>
              <IonIcon icon={icon_map} />
            </div>
            <span className="edisu-residence-info-text">
              {residence.indirizzo + ' ' + residence.comune[0] + residence.comune.slice(1).toLowerCase() + ' ' + residence.cap}
            </span>
          </div>
          {residence.telefono && (
            <div className="edisu-residence-info">
              <div>
                <IonIcon icon={icon_phone} />
              </div>
              <span className="edisu-residence-info-text">{residence.telefono}</span>
            </div>
          )}
        </div>
        <div className="position-cnt">{residence.gradimento >= 0 && <Rating value={residence.gradimento} />}</div>
        {residence.coordinate && (
          <a href={'https://www.muoversiatorino.it'} target="_blank" rel="noopener noreferrer">
            {t('view_maps')}
          </a>
        )}
      </div>
    </div>
  )
}

export default ResidenceDetailHeader
